import { render, staticRenderFns } from "./EditTemplateElements.vue?vue&type=template&id=6b79f9dc"
import script from "./EditTemplateElements.vue?vue&type=script&lang=js"
export * from "./EditTemplateElements.vue?vue&type=script&lang=js"
import style0 from "./EditTemplateElements.vue?vue&type=style&index=0&id=6b79f9dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports